import Icon from 'veui/components/Icon'

Icon.register({
  'file-search': {
    paths: [
      {
        d: 'M384 704a32 32 0 01-32 32H128a32 32 0 01-32-32V64a32 32 0 0132-32h512a32 32 0 0132 32v256a32 32 0 01-64 0V96H160v576h192a32 32 0 0132 32zM256 192a32 32 0 000 64h256a32 32 0 000-64zm128 160H256a32 32 0 000 64h128a32 32 0 000-64zm342.63 373.63a32 32 0 01-45.26 0l-45-45A142.59 142.59 0 01559.5 703C480.37 703 416 638.63 416 559.5S480.37 416 559.5 416 703 480.37 703 559.5a142.62 142.62 0 01-21.61 75.64l45.24 45.23a32 32 0 010 45.26zM639 559.5a79.5 79.5 0 10-79.5 79.5 79.59 79.59 0 0079.5-79.5z'
      }
    ],
    width: '768',
    height: '768'
  }
})
